/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { FC } from "react";
import { HiChevronLeft as PreviousIcon } from "react-icons/hi";

import Label from "components/Label";
import Button from "components/Button";
import { Step } from "../Flow/types";

import styles from "./styles.module.scss";

type Props = {
  steps: Step[];
  currentStep: number;
  setCurrentStep(newStep: number): void;
};

const StepProgress: FC<Props> = ({ steps, currentStep, setCurrentStep }) => {
  const { progressLabel } = steps[currentStep];

  return (
    <div className={styles.container}>
      <div className={styles.prorgessContainer}>
        <div
          style={{ width: `${(currentStep / steps.length) * 100}%` }}
          className={styles.progress}
        />
      </div>
      <div className={styles.content}>
        <Button
          className={styles.previousButton}
          onClick={() => {
            if (currentStep) setCurrentStep(currentStep - 1);
          }}
          Icon={<PreviousIcon />}
        />
        <div className={styles.info}>
          <Label variant="capitalized-centered-small" color="white">
            {progressLabel}
          </Label>
        </div>
      </div>
    </div>
  );
};

export default StepProgress;
